<template>
                          <v-autocomplete
                            :items="allShops"
                            :filter="customFilter"
                            v-model="valFindShop"
                            @change="selectFind"
                            :color="colorF"
                            item-text="nameK"
                            item-value="id"
                            label="Поиск"
                            :light="themeF"
                            class="mt-0 pa-0 autocompl"
                          ></v-autocomplete> 
</template>

<script>


  export default {
    name: 'FindShopMob',
      components: {

        },
  props: ['colorF','themeF'],
  data() {
      return {
        classes: [],
        valFindShop: '',

     
      }
    },
    computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },      
        categories: {
          get () {
            return this.$store.getters.getCategories;
          }
        },       
    allShops() {  
          let allShops= this.$store.state.shops.shops;
          let filterOnly = allShops.filter((allI)=>{
           return (!allI.category.includes('50') && !allI.category.includes('43') && !allI.category.includes('37'));
          });
          if(DEBUG) console.log('filterOnly :', filterOnly);
            return filterOnly;
          },
    isViewFind: {
      get() {
        return this.$store.state.app.isViewFind;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setIsViewFind", val);
      },
    },          
        currentShop: {
          get () {
            return this.$store.state.shops.currentShop;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentShop', val)
          }
        },
        loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }          
        },         
    },
    methods:{
      customFilter (item, queryText, itemText) {
        //const textOne = item.findArray.toLowerCase()
        const textOne = item.findArray
      //  const textTwo = item.abbr.toLowerCase()
        const searchText = queryText.toLowerCase()        
/*         if(DEBUG) console.log('queryText :', searchText);
        if(DEBUG) console.log('itemText :', itemText);
        if(DEBUG) console.log('item.findArray :', item.findArray);  
        if(DEBUG) console.log('return :', textOne.find(rf=>rf.toLowerCase().indexOf(searchText) > -1)); */
        
        return textOne.find(rf=>rf.toLowerCase().indexOf(searchText) > -1)
      }, 
      selectFind(){
        let vApp = this;
        if(DEBUG) console.log('selectFind :', vApp.valFindShop);
        //vApp.goToPage ('/shops/'+vApp.valFindShop);
        vApp.goToShop (vApp.valFindShop);
      },
      goToShop(idShop){
        let vApp = this;
        if(DEBUG) console.log('nShop :', idShop);
        vApp.isViewFind = false
        vApp.currentShop = vApp.allShops.find(ffsh=>ffsh.id===idShop);

      for (let index = 0; index < vApp.categories.length; index++) {
        const elc = vApp.categories[index];
        
        if(DEBUG) console.log('elc.category :>> ', elc.category);
        let findSubC = elc.category.find(fsc=>fsc.id === vApp.currentShop.category[0]);
        if( typeof findSubC !== 'undefined'  ){
          if(DEBUG) console.log('  SUBCATEGORY findSubC :>> ', findSubC);
          if(DEBUG) console.log('elc.id :>> ', elc.id);



              switch (elc.id) {
                case '10':
                  vApp.$router.push('/'+vApp.loadPathData.mnuShopsPath+'/'+vApp.currentShop.slug);
                  break;
                case '15':
                  vApp.$router.push('/'+vApp.loadPathData.mnuCafePath+'/'+vApp.currentShop.slug);
                  break;

                case '16':
                  vApp.$router.push('/'+vApp.loadPathData.mnuEntertatmentPath+'/'+vApp.currentShop.slug);
                  break;
                case '17':
                  vApp.$router.push('/'+vApp.loadPathData.mnuServicePath+'/'+vApp.currentShop.slug);
                  break;
              
                default:
                  break;
              }
        }
      }


      //  vApp.$router.push('/'+vApp.loadPathData.mnuShopsPath+'/'+vApp.currentShop.slug);
      },      
      goToPage (url) {
        let vApp = this;
        vApp.drawer = false;
        setTimeout(function() {
              vApp.$router.push(url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
        }, 500);

      },    
    },
    mounted() {
    if(DEBUG) console.log('mounted FindShop = ', this)
    let vApp = this
    this.$nextTick(function () {

    })

    },
  beforeDestroy: function () {
      let vApp = this;
      if(DEBUG) console.log("beforeDestroy");

  }    
  }
</script>

<style >
.swiper-pos{
  position: absolute;
}
.swiper-slider{
  
  height: 100vh;
}
.slide-home{
  width: 100%;
  height: 100vh;
  
}
.fill-height-2{
  height: 88%;
}
.dwnlayer-slider{
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 202;
}
.uplayer-slider{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 201;
}
.full-screen{
  width:100%;
  height: 100vh;
}

.arrowl-slider{
width: 70px;
height: 300px;
margin-left: 200px;
margin-top: -132px;
background-image: url('../assets/arr-l-w.svg');
cursor: pointer;
}

.arrowr-slider{
width: 70px;
height: 300px;
margin-right: 200px;
margin-top: -132px;
background-image: url('../assets/arr-r-w.svg');
cursor: pointer;
}

.swiper-button-prev:after, .swiper-button-next:after{
content: none;
}



</style>